"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFollowings = exports.getFollowers = exports.UnFollowUser = exports.FollowUser = void 0;
const client_1 = require("../../utils/client");
const queries_1 = require("../../utils/queries");
const FollowUser = (profile, token) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        client_1.client
            .mutation(queries_1.CREATE_FOLLOW_TYPED_DATA, {
            request: {
                follow: [
                    {
                        profile,
                    },
                ],
            },
        }, {
            fetchOptions: {
                headers: {
                    'x-access-token': token,
                },
            },
        })
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.FollowUser = FollowUser;
const UnFollowUser = (profile, token) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        client_1.client
            .mutation(queries_1.CREATE_FOLLOW_TYPED_DATA, {
            request: {
                profile,
            },
        }, {
            fetchOptions: {
                headers: {
                    'x-access-token': token,
                },
            },
        })
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.UnFollowUser = UnFollowUser;
const getFollowers = (address, limit) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        client_1.client
            .query(queries_1.GET_FOLLOWERS, {
            request: {
                address,
                limit,
            },
        })
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.getFollowers = getFollowers;
const getFollowings = (address, limit) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        client_1.client
            .query(queries_1.GET_FOLLOWING, {
            request: {
                address,
                limit,
            },
        })
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.getFollowings = getFollowings;
